var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"weixinShare",on:{"click":_vm.closeTip}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weixinShareCon"},[_c('div',{staticClass:"weixinShare-img"},[_c('img',{attrs:{"src":require("../../assets/wxShareArrowIcon.png")}})]),_c('div',{staticClass:"weixinShare-txt"},[_c('p',[_vm._v("点击右上角")]),_c('p',[_vm._v("将它分享给朋友")])])])
}]

export { render, staticRenderFns }